module.exports = __webpack_public_path__ + "static/media/submit.85790ea7.png";